export enum DateStatus {
	Bigger,
	InRange,
	Smaller,
	WithoutTime
}
